import { cn } from '@/utils/ui/styles'

import { Skeleton } from '../ui/skeleton'

type GridSkeletonProps = {
	length: number
	className?: string
	cardClassName?: string
}

/**
 * Grid skeleton component for displaying a grid of skeletons
 */
export const GridSkeleton = ({
	length,
	className,
	cardClassName,
}: GridSkeletonProps) => {
	return (
		<div
			className={cn('grid gap-4', className, {
				'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4': !className,
			})}
		>
			{Array.from({ length }).map((_, index) => (
				<Skeleton
					key={index}
					className={cn('h-auto min-h-50 w-full', cardClassName)}
				/>
			))}
		</div>
	)
}
